import React from "react";
import { ECLSendMessage } from "../../index";
import "./ECLUserProfile.css";
import { translate } from "../../../utilities/Translate";

export default function ECLUserProfile(props) {
   //PROPS
   // user - user object
   // {
   //    "username": "am",
   //    "id": "f103f2a4-dfc7-b790-1424-167bd792f8ae",
   //    "avatar": "__CUSTOM",
   //    "deactivated": false,
   //    "roles": [
   //    "Admin"
   //    ],
   //    "metadata": {
   //    "email": "",
   //    "Email": "",
   //    "Hobby": "",
   //    "Job Title": "",
   //    "Last Name": ""
   //    },
   //    "SCIM": false
   // }
   // avatarSrc - src string for avatar
   return (
      <div className="user-profile">
         <header>
            <h4>{props.user.username}</h4>
            <img
               className="avatar"
               id={"avatar-" + props.user.id}
               src={props.avatarSrc}
               alt={translate(props.user.username + " avatar")}
            />
         </header>
         <section className="contact-section">
            <div className="section-heading">
               <h5>Contact Information</h5>
               <div className="separator-line"></div>
            </div>
            <div className="values-display">
               {Object.keys(props.user.metadata).map((key) => {
                  return (
                     <div key={key} className="value">
                        <label>{key}</label>
                        <p>{props.user.metadata[key]}</p>
                     </div>
                  );
               })}
            </div>
         </section>
         <section className="message-section">
            <div className="section-heading">
               <h5>Send Message</h5>
               <div className="separator-line"></div>
            </div>
            <div className="message-sender-section">
               <ECLSendMessage userId={props.user.id} />
            </div>
         </section>
      </div>
   );
}
